import restClient from 'config/httpClient';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { redirect } from 'utils/utils';
import { setLocalStorageItem } from 'utils/localStorage';
import { getEntityId } from 'modules/entity/selectors';
import { PENDING_SIGNATURE_STORAGE_KEY } from 'modules/entity/constants';
import { getUnsignedDocuments } from 'modules/entity/selectors/global';
import { INTERVENTION_UPDATE_MODAL_TYPES } from 'works/components/Content/components/Common/modalUtils';

import { createNotification } from 'modules/notifications/actions';
import { openInterventionUpdateModal } from 'modules/works/actions';

import * as payActions from '../actions/payment';
import * as actionTypes from '../actionTypes';

const PAY_ACTIONS = {
  [actionTypes.PAY_ONLINE]: {
    success: payActions.payOnlineSuccess,
    failure: payActions.payOnlineFailure,
    failureMessage: {
      id: 'web.online-payment.failure',
      defaultMessage: 'An error has occurred during the payment.',
    },
  },
  [actionTypes.PAY_DEPOSIT]: {
    success: payActions.payDepositSuccess,
    failure: payActions.payDepositFailure,
    failureMessage: {
      id: 'web.online-payment.deposit.failure',
      defaultMessage: 'An error has occurred during the deposit payment.',
    },
  },
};

export function* setSignatureFlagBeforeRedirect() {
  const unsignedDocuments = yield select(getUnsignedDocuments);
  if (unsignedDocuments.length > 0) {
    const entityId = yield select(getEntityId);
    setLocalStorageItem(PENDING_SIGNATURE_STORAGE_KEY, entityId);
  }
}

export function* pay({ type, payload }) {
  const { request } = payload;
  const { success, failure, failureMessage } = PAY_ACTIONS[type];

  try {
    const { data: payment } = yield call(restClient.request, request);
    yield put(success());
    yield call(setSignatureFlagBeforeRedirect);
    try {
      yield call(redirect, payment.redirectUrl);
    } catch {
      yield put(
        createNotification({
          type: 'error',
          message: {
            id: 'web.error.file.common',
            defaultMessage: 'An error has occurred.',
          },
        })
      );
    }
  } catch (error) {
    yield put(failure(error));
    if (error.response?.status === 409) {
      yield put(openInterventionUpdateModal(
        { type: INTERVENTION_UPDATE_MODAL_TYPES.ADVICE_VERSION }
      ));
    } else {
      yield put(createNotification({ type: 'error', message: failureMessage }));
    }
  }
}

export function* payFinalInvoice({ payload }) {
  const { request } = payload;

  try {
    const { data: payment } = yield call(restClient.request, request);
    yield put(payActions.payFinalInvoiceSuccess());
    yield call(setSignatureFlagBeforeRedirect);
    yield call(redirect, payment.redirectUrl);
  } catch (error) {
    yield put(payActions.payFinalInvoiceFailure(error));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'web.contact-form.failure',
          defaultMessage: 'An error has occurred while sending your request',
        },
      })
    );
  }
}

export default function* paymentSagas() {
  yield takeLatest(payActions.payFinalInvoice, payFinalInvoice);
  yield takeLatest([payActions.payOnline, payActions.payDeposit], pay);
}
